package ui.component.external

import react.*
import react.dom.html.ReactHTML
import ui.component.buttons.miniIconButton
import ui.styles.ToastStyles
import ui.styles.icons.CloseRoundedIconSVG
import ui.themePlusContext.ToastData
import ui.themePlusContext.ToastProvider
import ui.themePlusContext.ToastTypes
import web.cssom.ClassName
import web.timers.clearTimeout
import web.timers.setTimeout
import kotlin.time.DurationUnit
import kotlin.time.toDuration


/**
 * Передоваемые данные в [ToastBuilder]
 *
 * @param message сообщение
 * @param close закрыти toast
 */
external interface ToastBuilderProps: Props {
    var data: ToastData
    var close: () -> Unit
}

/**
 * Конструктор компонента для отображения сообщения (для одного элемента список создаётся в [ToastProvider])
 */
val ToastBuilder = FC<ToastBuilderProps>{props ->

    val message = props.data.message
    val close = props.close

    val typeToAdd = when(props.data.type){
        ToastTypes.ERROR -> ToastTypes.ERROR.typeText
        ToastTypes.INFO -> ToastTypes.INFO.typeText
        ToastTypes.WARNING -> ToastTypes.WARNING.typeText
        ToastTypes.SUCCESS -> ToastTypes.SUCCESS.typeText
    }

    if (props.data.closable){
        useTimeoutToast(
            duration = props.data.timeout
        ) {
            close()
        }
    }


    ReactHTML.div{
        className = ClassName(ToastStyles.toast.toString().plus(" ").plus(typeToAdd))

        ReactHTML.p{
            className = ClassName(ToastStyles.toastMessage.toString().plus(" ").plus(typeToAdd))

            +message
        }

        if (props.data.closeBtn){
            miniIconButton{
                this.onClick = { close() }
                this.realIconSVG = CloseRoundedIconSVG
            }
        }


    }
}

fun useTimeoutToast(
    duration: Int = 3000,
    callback: () -> Unit
) {
    val saveCallback = useRef(callback)

    useEffect(
        dependencies = arrayOf(callback)
    ) {
        saveCallback.current = callback
    }

    useEffectOnceWithCleanup {
        val timeoutId = setTimeout(
            timeout = (duration / 1000).toDuration(DurationUnit.SECONDS)
        ){
            saveCallback.current?.invoke()
        }

        this.onCleanup {
            clearTimeout(timeoutId)
        }
    }
}